import _actions_edit from './_actions/edit.js'
import _actions_change_filter from './_actions/change_filter.js'
import _actions_change from './_actions/change.js'
import _getters_max_dateInt from './_getters/max_dateInt.js'
import _getters_filters from './_getters/filters.js'
import _getters_filter from './_getters/filter.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    getters:{
        filter: _getters_filter,
        filters: _getters_filters,
        max_dateInt: _getters_max_dateInt,
    },
    actions:{
        change: _actions_change,
        change_filter: _actions_change_filter,
        edit: _actions_edit,
    },
}